import React, {useMemo} from 'react'
import Table from '@material-ui/core/Table'
import {TableBody, TableCell, TableHead, TableRow} from '@material-ui/core'
import useProductUsageHistoryStyles from 'pages/ProductUsageHistory/style'
import {
  BULK_TABLE_COLUMN,
  KEY_TABLE_LOGS,
  MONTHLY_TABLE_COLUMN,
} from 'pages/ProductUsageHistory/constant'
import {useTranslation} from 'react-i18next'
import {formatDate} from 'helpers/dateHelper'
import {BulkDataTable, MonthlyDataTable} from 'pages/ProductUsageHistory/util'

type Props = {
  dataTable: MonthlyDataTable[] | BulkDataTable[]
  type: 'monthly' | 'bulk' | 'manual'
}
const TableLogs = ({dataTable, type}: Props) => {
  const {t, i18n} = useTranslation()
  const classes = useProductUsageHistoryStyles()

  const listColumn = useMemo(() => {
    if (type === 'monthly') return MONTHLY_TABLE_COLUMN
    if (type === 'bulk') return BULK_TABLE_COLUMN
    return []
  }, [type, i18n.language])

  const renderCellContent = (
    row: MonthlyDataTable | BulkDataTable,
    key: string,
  ) => {
    if (key === KEY_TABLE_LOGS.USAGE_DATE_TIME) {
      // @ts-ignore
      const dateValue = row.usageDateTime
      return dateValue ? formatDate(new Date(dateValue)) : ''
    }
    // @ts-ignore
    return row[key] ?? ''
  }

  const getTotalAmount = (key: string) => {
    const total = dataTable.reduce(
      (acc, row) => {
        const value = row[key]

        if (value === t('IUnlimited')) {
          acc.hasLifetime = true
        } else if (typeof value === 'number') {
          acc.sum += value
        }

        return acc
      },
      {sum: 0, hasLifetime: false},
    )

    if (total.hasLifetime) {
      return t('IUnlimited')
    }

    return total.sum
  }

  return (
    <Table size='small' className={classes.table}>
      <TableHead className={classes.tableHeader}>
        {listColumn.map((item) => (
          <TableCell
            align='center'
            padding='checkbox'
            key={item.id}
            style={{
              whiteSpace: 'pre',
            }}
          >
            {t(item.label)}
          </TableCell>
        ))}
      </TableHead>
      <TableBody>
        {dataTable.map((row, index: number) => (
          <TableRow key={`${row.usageId}-${index}`}>
            {listColumn.map((col) => (
              <TableCell key={col.id} align='center'>
                {col.key === KEY_TABLE_LOGS.index ? (
                  <span>{dataTable.length - index}</span>
                ) : (
                  renderCellContent(row, col.key)
                )}
              </TableCell>
            ))}
          </TableRow>
        ))}
        <TableRow>
          <TableCell align='center' colSpan={4}>
            {t('ITotal')}
          </TableCell>
          {type === 'monthly' && (
            <>
              <TableCell align='center' />
              <TableCell align='center'>
                {getTotalAmount('manualPayment')}
              </TableCell>
              <TableCell align='center'>
                {getTotalAmount('rechargeCurrentMonth')}
              </TableCell>
              <TableCell align='center'>
                {getTotalAmount('rechargeCarryover')}
              </TableCell>
              <TableCell align='center'>{getTotalAmount('use')}</TableCell>
            </>
          )}
          <TableCell align='center' />
        </TableRow>
      </TableBody>
    </Table>
  )
}

export default TableLogs
